import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", { d: "M19 9a3 3 0 00-2.82 2H3a1 1 0 000 2h13.18A3 3 0 1019 9zm0 4a1 1 0 110-2 1 1 0 010 2zM3 7h1.18a3 3 0 005.64 0H21a1 1 0 000-2H9.82a3 3 0 00-5.64 0H3a1 1 0 100 2zm4-2a1 1 0 110 2 1 1 0 010-2zM21 17h-7.18a3 3 0 00-5.64 0H3a1 1 0 000 2h5.18a3 3 0 005.64 0H21a1 1 0 000-2zm-10 2a1 1 0 110-2 1 1 0 010 2z" })
		})
	})
});
export { SvgFilter as ReactComponent };
